/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StartDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StartDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content/StartDate"
  
}) {
let treatmentStartDateValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'start_date',
})
let treatmentEstimatedStartDateValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'estimated_start_date',
})
let aggregateData = fromHelpers.getDate(treatmentStartDateValueData, treatmentEstimatedStartDateValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="StartDate.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="treatment.start_date"
 data="treatment.estimated_start_date"
 aggregate="helpers.js getDate"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}